"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContextStore = /** @class */ (function () {
    function ContextStore() {
        this.contextByKey = {};
    }
    ContextStore.prototype.get = function (options) {
        var contextParentKey = options.contextParentKey, contextKey = options.contextKey;
        return this.contextByKey && this.contextByKey[contextParentKey] && this.contextByKey[contextParentKey][contextKey];
    };
    ContextStore.prototype.set = function (options) {
        var contextParentKey = options.contextParentKey, contextKey = options.contextKey, value = options.value;
        if (contextParentKey && contextKey && value) {
            if (!this.contextByKey) {
                this.contextByKey = {};
            }
            if (!this.contextByKey[contextParentKey]) {
                this.contextByKey[contextParentKey] = {};
            }
            this.contextByKey[contextParentKey][contextKey] = value;
        }
    };
    return ContextStore;
}());
exports.ContextStore = ContextStore;
//# sourceMappingURL=ContextStore.js.map